<template>
  <card class="card" title="Editar estación">
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="number"
              label="No. Estación*"
              placeholder="Número de estación*"
              v-model="form.station"
              maxLength="5"
              :class="{
               'is-invalid': submitted && $v.form.station.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.station.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.station.required"
                >Requerido</span
              >
              <span v-if="!$v.form.station.minLength || !$v.form.station.maxLength"
                >Se requieren 5 valores númericos</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre*"
              placeholder="Nombre"
              v-model="form.name"
              :class="{
               'is-invalid': submitted && $v.form.name.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.name.required"
                >Requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre comercial*"
              placeholder="Nombre comercial"
              v-model="form.commercial_name"
              :class="{
               'is-invalid': submitted && $v.form.commercial_name.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.commercial_name.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.commercial_name.required"
                >Requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="RFC*"
              placeholder="RFC"
              v-model="form.rfc"
              maxLength="13"
              :class="{
                'is-invalid': submitted && $v.form.rfc.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.rfc.$error"
              class="invalid-feedback"
            >
              <!-- <span v-if="!$v.form.rfc.required"
                >Requerido</span
              ><br/> -->
              <span v-if="!$v.form.rfc.validateRfc"
                >Ingrese un formato valido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>Estatus*</label>
            <vSelect :options="statusJSON" placeholder="Selecciona un estatus" v-model="form.status" :class="{
              'is-invalid': submitted && $v.form.status.$error
            }" />
            <div v-if="submitted && $v.form.status.$error" class="invalid-feedback">
              <span v-if="!$v.form.status.required">El estatus es requerido</span>
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Fecha de vencimiento"
              placeholder="expiration_date"
              v-model="form.expiration_date"
              :min='currentDate'
              :class="{
                'is-invalid': submitted && $v.form.expiration_date.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.expiration_date.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.expiration_date.required"
                >Requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Fecha alta*"
              v-model="form.affiliation_date"
              disabled
              :class="{
               'is-invalid': submitted && $v.form.affiliation_date.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.affiliation_date.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.affiliation_date.required"
                >Requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Fecha ultimo respaldo*"
              v-model="form.last_backup"
              :class="{
                'is-invalid': submitted && $v.form.last_backup.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.last_backup.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.last_backup.required"
                >Requerido</span
              >
            </div>
          </div>
        </div>

        <div><br/>
          <p-button
            type="info"
            @click.native.prevent="handleSubmit"
            style="margin-right: 10px;"
            >
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import stationsService from '../../services/stationsService';
import { dateFormat } from "../../helpers";
import vSelect from "vue-select";
import store from "../../store";

const regex = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
function validateRfc() {
  const resul = this.form.rfc.match(regex);
  if (resul === null) {
    return false;
  } else {
    return true;
  }
}

export default {
  components: {
    vSelect
  },
  mounted () {
    const id = this.$route.params.id;
    stationsService.getByID(id).then(response => {
      const date_backup = response.data.data.last_backup && response.data.data.last_backup.split('T')
      const date_affiliation = response.data.data.affiliation_date && response.data.data.affiliation_date.split('T')
      const expiration_date = response.data.data.expiration_date && response.data.data.expiration_date.split('T')
      this.form.id = response.data.data.id
      this.form.station = response.data.data.station
      this.form.affiliation_date = date_affiliation[0]
      this.form.name = response.data.data.name
      this.form.commercial_name = response.data.data.commercial_name
      this.form.rfc = response.data.data.rfc
      this.form.expiration_date = expiration_date
      this.form.status = response.data.data.status === 1 ? 'Activo' : 'Inactivo'
      this.form.last_backup = date_backup[0]
      this.form.expiration_date = expiration_date[0]
    })
  },
  data() {
    return {
      form: {
        version: 0,
        estacion: "",
        affiliation_date: "",
        commercial_name: "",
        rfc: "",
        last_backup: "",
        name: "",
        status: "Activo",
        expiration_date: ""
      },
      statusJSON: ["Activo", "Inactivo"],
      submitted: false,
      currentDate: dateFormat().toString()
    };
  },
  validations: {
    form: {
      station: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      affiliation_date: { required },
      commercial_name: { required },
      rfc: { required, validateRfc },
      last_backup: { required },
      name: { required },
      status: { required }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      stationsService.update(this.$route.params.id, this.form).then(response => {
        if(response.data.error === false) {
          swal({
            title: 'Exitoso',
            text: 'Se actualizo la estación correctamente',
            icon: 'success',
            timer: 3000,
            buttons: false
          })
          localStorage.removeItem('stationsJSON')
          store.dispatch('actionGetStations')
          setTimeout(()=> {
            this.$router.push('/estaciones');
          }, 3000)
        } else {
          swal({
            title: '¡Algo salio mal!',
            text: 'Consulte con el administrador',
            icon: 'warning',
            timer: 3000,
            buttons: false
          })
        }
      })

    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/estaciones");
        }
      })
    }
  },
};
</script>
<style></style>
